import { getAction } from '../utils/request'
export function listFollows(data) {
    return getAction('/web/follow/listFollows',data)
  }
  